import React, { FC } from 'react';
import styled from 'styled-components';
import { CourseBundleListItemDurationTag } from 'src/courseBundle/components/CourseBundleListItem/CourseBundleListItemDurationTag';
import { CourseBundleListItemDateTag } from 'src/courseBundle/components/CourseBundleListItem/CourseBundleListItemDateTag';
import { CourseBundleListItemContent } from './CourseBundleListItemContent';
import { colors, shadows } from 'src/config/colors';
import SmallCtaIcon from 'src/assets/icons/SmallCtaIcon';
import { CourseExcerpt } from 'src/common/models/courseExcerpt';
import { CourseBundleListItemImage } from 'src/courseBundle/components/CourseBundleListItem/CourseBundleListItemImage';
import { CourseType } from 'src/common/models/courseType';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding-bottom: 0.625rem;
`;

const Box = styled.div`
  background: ${colors.white};
  box-shadow: ${shadows.drop1};
  border-radius: 0.375rem;
  display: flex;
  position: relative;
  padding: 0.625rem 1.5rem;
  width: 100%;
`;

const StyledSmallCtaIcon = styled(SmallCtaIcon)`
  bottom: 0.625rem;
  color: ${colors.red};
  opacity: 0;
  position: absolute;
  right: 0.625rem;
  transition: opacity 0.2s ease;
`;

export interface CourseBundleListItemProps {
  courseExcerpt: CourseExcerpt;
}

export const CourseBundleListItem: FC<CourseBundleListItemProps> = ({ courseExcerpt }) => (
  <Container>
    <Box>
      {courseExcerpt.courseType === CourseType.StandardCourse ? (
        <CourseBundleListItemDateTag date={courseExcerpt.date} />
      ) : (
        <CourseBundleListItemDurationTag duration={courseExcerpt.duration} />
      )}
      {courseExcerpt.image && <CourseBundleListItemImage image={courseExcerpt.image} />}
      <CourseBundleListItemContent title={courseExcerpt.title} speaker={courseExcerpt.speaker} />
      <StyledSmallCtaIcon size={18} />
    </Box>
  </Container>
);
